import React, { FC } from 'react';

import { FlowIdTypes } from '@folx-types/flow';
import { IFlowStepProps } from '@folx-types/flow-steps';

import NewAppointmentBooked from '@components/NewAppointmentBooked';

interface INewAppointmentBookingStepProps extends IFlowStepProps {
	serviceType?: FlowIdTypes;
	path: string;
}

const NewAppointmentBookedStep: FC<INewAppointmentBookingStepProps> = ({ serviceType }) => {
	const paymentNotRequiredPath = `/app/flows/appointment_booking/${serviceType}/confirmed`;

	return <NewAppointmentBooked paymentNotRequiredPath={paymentNotRequiredPath} />;
};

export default NewAppointmentBookedStep;
